export default {
  getSignedUrl: "/spaces/presigned_url",
  createAssessment: '/assessment/createAssessment',
  getAssessmentsOfADivision: '/assessment/getAssessmentsOfADivision',
  assessmentAsDraft: '/assessment/assessmentAsDraft',
  deleteAssessment: '/assessment/deleteAssessment',
  updateAssessmentDetails: '/assessment/updateAssessmentDetails',
  generateSampleMarksExcel: '/excel/assessment/generateSampleMarksExcel'
};
